import {z} from '@hono/zod-openapi';

const numericDate = z.number().int().nonnegative().safe();
const base = {
  iss: z.literal('prompt-bridge-api'),
  sub: z.literal('prompt-bridge-api'),
  aud: z.literal('prompt-bridge-voice-gateway'),
  iat: numericDate,
  exp: numericDate,
  jti: z.string().uuid(),
  bodySha256: z.string().regex(/^[0-9a-f]{64}$/),
};
const owner = {ownerId: z.string().uuid()};
export const VoiceDebugGatewayClaimsSchema = z
  .discriminatedUnion('operation', [
    z.object({...base, operation: z.literal('profiles')}).strict(),
    z.object({...base, ...owner, operation: z.literal('reserve')}).strict(),
    z
      .object({
        ...base,
        ...owner,
        sessionId: z.string().uuid(),
        operation: z.enum(['offer', 'ready', 'state', 'events', 'hangup']),
      })
      .strict(),
  ])
  .superRefine((claims, context) => {
    if (claims.exp <= claims.iat || claims.exp - claims.iat > 60) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['exp'],
        message: 'exp must be after iat by at most 60 seconds',
      });
    }
  })
  .openapi('VoiceDebugGatewayClaimsSchema');
export type VoiceDebugGatewayClaims = z.infer<typeof VoiceDebugGatewayClaimsSchema>;
export type VoiceDebugGatewayOperation = VoiceDebugGatewayClaims['operation'];
